import React, { useState, useEffect, useRef } from 'react';
import Help from "@material-ui/icons/Help";
import reset from '../Helpsection_images/reset.jpg';
import Resetall from '../Helpsection_images/Resetall.jpg';
import search from '../Helpsection_images/search.jpg';
import Exporttoexcel from '../Helpsection_images/Exporttoexcel.jpg';
import searchicon from '../Helpsection_images/searchicon.jpg';
import printicon from '../Helpsection_images/printicon.jpg';
import downloadicon from '../Helpsection_images/downloadicon.jpg';
import viewcolumnicon from '../Helpsection_images/viewcolumnicon.jpg';
import filtericon from '../Helpsection_images/filtericon.jpg';
import email from '../Helpsection_images/email.jpg';
import Agree from '../Helpsection_images/Agree.jpg';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import {
  BreadcrumbPage
} from "../../shared";
import {
  Box,
  FormControlLabel,
  Checkbox,
  FormGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,

} from '@material-ui/core';
import {
  tableCellClasses
} from '@mui/material/TableCell';
import {
  styled
} from '@mui/material/styles';
import clsx from "clsx";
import { Grid } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import { Typography } from "@material-ui/core";

import {
  withStyles,
  makeStyles
} from "@material-ui/core/styles";
import {
  InputBase,
  Button
} from "@material-ui/core";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from "@material-ui/core/FormControl";
import Select from '@material-ui/core/Select';
import { getCookie } from "../../services/Cookies";
import EllipsisText from "react-ellipsis-text";
import MenuItem from '@material-ui/core/MenuItem';
import download from 'downloadjs';
import {
  DatePicker, KeyboardDatePicker
} from '@material-ui/pickers';
import { postRequest, getRequest } from "../../services/ApiServices";
import { ToastError } from "../../services/ToastMsg";
import { LOADING } from "../../action";
import { useDispatch } from "react-redux";
import { getCurrentDate, getCurrentDateOfBelow, getCurrentYearOfFiveBelow } from "../../services/DateServices";
import axios from "axios";
import moment from "moment";
import Moment from "react-moment";
import { set } from 'date-fns';
import { ThemeProvider } from "@mui/styles";
import { createTheme, responsiveFontSizes } from "@mui/material/styles";

import MUIDataTable from "mui-datatables";
import { AsyncPaginate } from "react-select-async-paginate";
//import { TablePagination } from '@material-ui/core';
import TablePagination from "../dataaccess/Tablepagination"
import CustomerPagination from "../dataaccess/CustomerPagination";
import { isEmpty } from 'lodash';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const getMuiTheme = () => createTheme({

  overrides: {
    MUIDataTableHeadCell: {
      root: {
        textTransform: "none"
      }
    }
  }
})
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));
const useStyles = makeStyles((theme) => ({
  tableBody: {
    "& .tss-10rusft-MUIDataTableToolbar-icon": {
      color: "#ff4717",
      boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
      marginLeft: "15px"

    },
    "& .tss-9z1tfs-MUIDataTableToolbar-iconActive": {
      color: "#ff4717",
      boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
      marginLeft: "15px"
    },
    "& .tss-qbo1l6-MUIDataTableToolbar-actions": {
      justifyContent: "left",
      position: "absolute",

    },
    "& .tss-1ufdzki-MUIDataTableSearch-main": {
      marginRight: "10px",
      width: 500
    },
    "& .tss-1fz5efq-MUIDataTableToolbar-left ": {
      position: "absolute",
      right: 17
    }
  },

 
}))
function createData(SampleNo, Agreement, Status, Registered, Port, Bunkered, Shipped, Arrived, Special) {
  return { SampleNo, Agreement, Status, Registered, Port, Bunkered, Shipped, Arrived, Special };
}

const rows = [
  createData('FUJ21F011787', 'CTR-001583-0002', 'REPORTED', '11 Dec 2021', 'MUMBAI', '02 Dec 2021', '04 Dec 2021', '1 1 Dec 2021', ' N/A'),
  createData('FUJ21F011787', 'CTR-001583-0002', 'REPORTED', '11 Dec 2021', 'MUMBAI', '02 Dec 2021', '04 Dec 2021', '1 1 Dec 2021', ' N/A'),
  createData('FUJ21F011787', 'CTR-001583-0002', 'REPORTED', '11 Dec 2021', 'MUMBAI', '02 Dec 2021', '04 Dec 2021', '1 1 Dec 2021', ' N/A'),
  createData('FUJ21F011787', 'CTR-001583-0002', 'REPORTED', '11 Dec 2021', 'MUMBAI', '02 Dec 2021', '04 Dec 2021', '1 1 Dec 2021', ' N/A'),
  createData('FUJ21F011787', 'CTR-001583-0002', 'REPORTED', '11 Dec 2021', 'MUMBAI', '02 Dec 2021', '04 Dec 2021', '1 1 Dec 2021', ' N/A'),
];

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(2),
    },
  },


  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "auto",
    padding: "10px 12px",
    height: "0.1876em",
    // marginLeft: '2.2em',
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
    "&.Mui-disabled": {
      cursor: "not-allowed",
      backgroundColor: "#e9ecef",
      border: "1px solid #ced4da"
    }
  },
}))(InputBase);

function Dataaccess(props) {
  const classes = useStyles();
  const BreadcrumbList = [{ name: "Downloads", url: "" }];
  const [dropdownvalue, setdropdownvalue] = React.useState(30);
  const [customerData, setCustomerData] = useState([]);
  const [contractstate, setcontractstate] = React.useState([]);
  const [startDateval, setstartDateval] = React.useState(365);
  const [checkBox, setcheckBox] = React.useState([]);
  const [contractDetails, setContractDetails] = React.useState([]);
  const [contractCustomerNamesDetails, setContractCustomerNamesDetails] = React.useState([]);
  const [contractListItems, setContractListItems] = useState([]);
  const [TypeofServiceData, setTypeOfServiceData] = React.useState([]);
  const [ContractData, setContractData] = React.useState("");
  const [assetData, setassetData] = React.useState("");
  const [serviceData, setserviceData] = React.useState("");
  const [FilterData, setFilterData] = React.useState([]);
  const [servicedataType, setservicedataType] = React.useState("");
  const [activeKey, setActiveKey] = React.useState("");
  const [resultsvalidate, setresultsvalidate] = React.useState(false);
  const [selectedValues, setSelectedValues] = React.useState([]);
  const [validate, setValidate] = useState(false);
  const [sellectAllcheck, setsellectAllcheck] = useState("");
  const [Duration, setDuration] = useState("Custom");
  const [selected, setSelected] = useState(false);
  const [formObj, setFormObj] = React.useState({ ReportedFromDate: getCurrentDateOfBelow(startDateval), ReportedToDate: getCurrentDate() });
  const [DialogEmail, setDialogEmail] = useState(false);
  const [value, onChange] = useState(null);
  const dispatch = useDispatch();
  const [openform, setOpenform] = React.useState(false);
  const [scroll, setScroll] = React.useState('paper');
 
  const handleClickClose = () => {
    setOpenform(false);
  };

  const handleClickOpenForm = (data) => {
    setOpenform(true);
  };
  const defaultAdditional = {
    page: 1
  };

  /*const loadPageOptions = async (q, prevOptions, { page }, data = contractListItems) => {
    console.log('loadpageoption', data);

     const { options, hasMore } = await loadOptions(q, page, data);

    return {
      options,
      hasMore,
      additional: {
        page: page + 1
      }
    };
  };
 */
  const handleClose = () => {
    setDialogEmail(false);
  };


  const handleDateData = (e, field) => {
    if (field == "Fromdate") {
      setFormObj({
        ...formObj,
        ReportedFromDate: e
      });
    } else if (field == "Todate") {
      setFormObj({
        ...formObj,
        ReportedToDate: e
      });
    }
    let thiru = formObj;
    console.log(thiru)
  }

  const funSamplefromdate = (value) => {


    if (value == "Last 1 Month") {
      return 30
    } else if (value == "Last 2 Month") {
      return 60
    } else if (value == "Last 6 Month") {
      return 183
    } else if (value == "Last 12 Month") {
      return 365
    } else if (value == "Last 24 Month") {
      return 730
    } else {
      return 0
    }
  }

  const ondropdown = (value) => {
    debugger
    setdropdownvalue(value);
    var val1 = funSamplefromdate(value);
    setstartDateval(val1);
    setFormObj({ ...formObj, ReportedFromDate: getCurrentDateOfBelow(val1) });
    setDuration(value)

  }

  useEffect(() => {
    //getContracts({ customerKeys: getCookie("clientId") });
    getCustomerData({ customerKey: getCookie("clientId") });
    /*   let getCookieval = getCookie('GlobalFilterSetting');
     if (getCookieval !== "" && getCookieval !== undefined && getCookieval !== "null") {
       let Obj = JSON.parse(getCookieval);
       getCustomerData(Obj.customerNameKey);
   } */
  }, []);

  const formObjFormat = {
    customerKey: getCookie("clientId"),
  }
  const getCustomerData = async (data) => {
    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `Customer`;
    await getRequest(url)
      .then((res) => {
        //console.log(res);
        if (res.status == 200) {
          // dispatch({ type: LOADING, payload: false });
          //console.log("Customer data", res.data);

          const img = res?.data?.map((CustData, idx) => {
            return {
              "id": CustData?.customerKey,
              "label": CustData?.customerName
            }
          });
          setCustomerData(img);
          console.log('CustData', img);
        } else {
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        // dispatch({ type: LOADING, payload: false });
        //console.log(error);
        // ToastError(error.response.data.message);
      });

  };


  const getContracts = (data) => {
    dispatch({ type: LOADING, payload: true });
    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `Contract`;
    postRequest(url, data)
      .then((res) => {
        if (res.status == 200) {
          dispatch({ type: LOADING, payload: false });
          setContractDetails(res.data);
          const dt = res.data;
          /** Remove the dublicates from data - > key : customerName  */
          var arr = [];
          var tmpArr = [];
          dt.map((item, index) => {
            const cName = item.customerName ? item.customerName : "";
            const cKey = item.contractKey ? item.contractKey : "";
            const cId = item.axContractId ? item.axContractId : "";
            var obj = { contractKey: cKey, customerName: cName, contractKey: cId };

            if (!arr.includes(cName)) {
              arr.push(cName);
              tmpArr.push(obj);
            }

          });
          setContractCustomerNamesDetails(tmpArr);
        } else {
          ToastError("res.data.message");
        }
      })
      .catch((error) => {
        setContractDetails([]);
        setContractCustomerNamesDetails([]);
        dispatch({ type: LOADING, payload: false });

      });
  };


  const getDataAccessfilter = () => {
    
    let data = {}
    let arr = []
    console.log(contractstate)
    let conv = sellectAllcheck ? "ALL" : selectedValues.join(",")
    data.customerKeys = conv  //[1,2,3,4,54]
    let val = selected ? "ALL" : checkBox.join(',');
    data.asset = val;
    data.Servicetype = servicedataType
    data.ReportedFromDate = formObj.ReportedFromDate;
    data.ReportedToDate = formObj.ReportedToDate;
    console.log(data);
    if (servicedataType == "") {
      setValidate(true)
    } else {
      dispatch({ type: LOADING, payload: true });
      const url =
        process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
        `Excelexport/Dataaccess/Filter`;
      postRequest(url, data)
        .then((res) => {
          debugger
          console.log("setFilterData : ", res);
          if (res.status == 200) {
            dispatch({ type: LOADING, payload: false });
            setValidate(false)
            res.data.forEach((d) => {
              if(d.bunkeringDt){
                const newFormat = 'YYYY-MM-DDTHH:mm:ss.SSS'
                d.bunkeringDt = moment(d.bunkeringDt, 'DD/MM/YYYY').format(newFormat);

              }
              if(d.arrivedonDt){
                const newFormat = 'YYYY-MM-DDTHH:mm:ss.SSS'
                d.arrivedonDt = moment(d.arrivedonDt, 'DD/MM/YYYY').format(newFormat);

              }
              if(d.shippedOnDt){
                const newFormat = 'YYYY-MM-DDTHH:mm:ss.SSS'
                d.shippedOnDt = moment(d.shippedOnDt, 'DD/MM/YYYY').format(newFormat);

              }
              if(d.registrationDt){
                const newFormat = 'YYYY-MM-DDTHH:mm:ss.SSS'
                d.registrationDt = moment(d.registrationDt, 'DD/MM/YYYY').format(newFormat);

              }
            })
            setFilterData(res.data);

            if (res.data == 0) {
              ToastError("No Record Found");
            }
          } else {
            ToastError("Try it later");
          }
        })
        .catch((error) => {
          console.log(error)
          setFilterData([]);
          dispatch({ type: LOADING, payload: false });

          ToastError("Try it later");
        });
    }
  };


  const getDataAccessServices = async (customerKeys) => {

    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `Excelexport/services`;
    const data = {
      customerKeys: customerKeys.toString(),
    }
    postRequest(url, data)
      .then((res) => {
        ////console.log(res);
        if (res.status == 200) {
          dispatch({ type: LOADING, payload: false });
          setTypeOfServiceData(res.data);
        } else {
          ToastError("res.data.message");
        }
      })
      .catch((error) => {
        setTypeOfServiceData([]);
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
        ToastError("error.response.data.message");
      });
  };


  const getVesselsUnderContract = (customerKeys) => {
    
    dispatch({ type: LOADING, payload: true });
    /* let arr=contractKeys.join(',') */
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Excelexport/AssetsUnderContract`;
    const data = {
      customerKeys: customerKeys,
    }
    postRequest(url, data)
      .then((res) => {

        if (res?.status == 200) {
          dispatch({ type: LOADING, payload: false });
          const cli = res?.data?.map((shipData, idx) => {
            return {
              "id": shipData?.propertyKey,
              //"value": shipData?.itemNo,
              "label": `${shipData?.itemNo} - ${shipData?.imoNo}`
            }
          });
          console.log('shipdata', cli);
          setContractListItems(cli);
          console.log(cli)
          return;

        }
        ToastError("res.data.message");
        dispatch({ type: LOADING, payload: false });
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        ToastError("Try again after some time or contact your help desk.....");
      });
  }

  const getDataAccess = (customerKeys) => {

    getDataAccessServices(customerKeys)
  }
  const onChangemethod = async (isChecked, value) => {
    let svalues = [...selectedValues];
    if (isChecked) {
      svalues.push(value);
    }
    else {
      svalues = svalues.filter((ele, index) => {
        return ele !== value;
      });
      //setSelectedValues(val)
    };
    setSelectedValues(svalues);
    getVesselsUnderContract(svalues.join());
    //getContractAccess(value)
    getDataAccess(svalues.join())
    contractstate.push(value)


  };
  const onSelectmethod = async (isChecked, value) => {
    if (isChecked == true) {
      let arr = []
      let finalvalue = value.map((e) => {
        arr.push(e.customerKey)
      })
      setcontractstate(arr)
      setsellectAllcheck(isChecked)
      setSelectedValues(arr);
      getVesselsUnderContract(arr.join());
      //getContractAccess(value)
      getDataAccess(arr.join())
      contractstate.push(value)
    } else {
      setSelectedValues([]);
      setsellectAllcheck(isChecked)
      setcheckBox([])
      setContractListItems([])

    }

  };

  const onclickmethod = (value, e) => {
    if (e == true) {
      checkBox.push(value.propertyKey)
      setassetData(value)
    } else {
      let intialvalue = checkBox.filter((ele) => {
        return ele !== value.propertyKey

      })
      setcheckBox(intialvalue)
      //setcheckBox(intialvalue);
      //setcheckBox([])
    }
  };

  const onretrievemethod = (isChecked, value) => {
    setSelected(isChecked)
    let arr = []
    if (isChecked == true) {
      let intialvalue = value.map((e) => e.propertyKey)
      /* checkBox.push(value.vesselKey) */
      setcheckBox(intialvalue);
      setassetData(value)
    } else if (isChecked == false) {
      setcheckBox([])
    }
  };
  const OnServicetypemethod = (value) => {
    setservicedataType(value)
    setValidate(false)

  };
  const Ontypemethod = (value) => {
    setActiveKey(value)
    setresultsvalidate(false)

  };
  const getSummaryResults = (value) => {
    //
    if (activeKey == "") {
      setresultsvalidate(true)
    } else {
      let data = {}
      let conv = sellectAllcheck ? "ALL" : selectedValues.join(",")
      data.customerKeys = conv
      let val = checkBox.join(',');
      data.asset = val;
      data.Servicetype = servicedataType
      data.ReportedFromDate = formObj.ReportedFromDate;
      data.ReportedToDate = formObj.ReportedToDate;
      if (value == 1) {
        debugger
        dispatch({ type: LOADING, payload: true });
        const token = getCookie("token");
        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Excelexport/SummaryExport/Filter`;
        let filedata = JSON.stringify(data);
        let config = {
          method: "post",
          responseType: "blob",
          timeout: 30000,
          url: url,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/vnd.ms-excel"
          },
          data: filedata,
        };
        const myTimeout = setTimeout(() => { console.log('printing1') }, 30000);
        axios(config)
          .then(async function (response) {

            //var blob = new Blob([ab], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });
            clearTimeout(myTimeout);

            const file = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file);
            //window.open(fileURL, '_blank')
            window.location = fileURL;
            dispatch({ type: LOADING, payload: false });
          })
          .catch(function (error) {
            debugger
            dispatch({ type: LOADING, payload: false });
            console.log(error);
            if (error.message == 'timeout of 30000ms exceeded') {
              setDialogEmail(true);
            }
          });
      } else {
        dispatch({ type: LOADING, payload: true });
        const token = getCookie("token");
        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Excelexport/DetailExport/Filter`;
        let filedata = JSON.stringify(data);
        let config = {
          method: "post",
          responseType: "blob",
          timeout: 30000,
          url: url,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/vnd.ms-excel"
          },
          data: filedata,
        };
        const myTimeout = setTimeout(() => { console.log('printing2') }, 30000);
        axios(config)
          .then(async function (response) {

            //var blob = new Blob([ab], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });

            clearTimeout(myTimeout);
            const file = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file);
            //window.open(fileURL, '_blank')
            window.location = fileURL;
            dispatch({ type: LOADING, payload: false });
          })
          .catch(function (error) {
            dispatch({ type: LOADING, payload: false });
            console.log(error);
            if (error.message == 'timeout of 30000ms exceeded') {
              setDialogEmail(true);
            }
          });
      }
    }
  };
  const sendEmailExcelExport = async (typeofdata) => {
    //
    let data = {}
    let conv = sellectAllcheck ? "ALL" : selectedValues.join(",")
    data.customerKeys = conv
    let val = checkBox.join(',');
    data.asset = val;
    data.Servicetype = servicedataType
    data.ReportedFromDate = formObj.ReportedFromDate;
    data.ReportedToDate = formObj.ReportedToDate;
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Excelexport/ExcelExportEmail/${typeofdata}`;
    dispatch({ type: LOADING, payload: true });
    await postRequest(url, data)
      .then((res) => {
        dispatch({ type: LOADING, payload: false });
        setDialogEmail(false);
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        //console.log(error);

      });

  }
  const OnResetchange = () => {
    setCustomerData([])
    setContractListItems([])
    setSelectedValues([])
    setTypeOfServiceData([])
    setFilterData([])
    setActiveKey("")
    setcheckBox([])
    setsellectAllcheck()
    setSelected()
    setservicedataType("")
    setDuration("Custom")
    setFormObj({ ReportedFromDate: new Date(), ReportedToDate: new Date() })
    getCustomerData({ customerKey: getCookie("clientId") });
  };

  const OnResetContract = () => {
    setSelectedValues([]);
    setsellectAllcheck()
    setContractListItems([])
    setSelected()


  };
  const OnResetAssets = () => {
    setContractListItems([])
    setSelected()


  };


  const onpropKeyChange = (e) => {

    if (typeof e === 'string') {
      setcheckBox([e])
      return;
    };
    setcheckBox(
      e.map((ele) => (ele?.id))
    );
  }
  const onCustomerKeyChange = (e) => {
    debugger
    const customerMappedKey = e?.map((customer) => customer?.id)
    const newSelectedCustomers = [...customerMappedKey];
    setSelectedValues(newSelectedCustomers);
    getVesselsUnderContract(newSelectedCustomers.join());
    getDataAccess(newSelectedCustomers.join())
  }
  const isDisplay = () => {
    if (servicedataType == 'TOT') return 'excluded'; 
    else return true;
  };
  const FilterDisplay = () => {
    if (servicedataType == 'TOT') return false; 
    else return true;
  };
  
  const columns = [
    {
      name: "sampleControlNoCd",
      label: "Sample No",
      options: {
        filter: true,
        sort: true,

      }
    },
    {
      name: "customerName",
      label: "Customer",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "registrationDt",
      label: "Registered On",
      options: {
        filter: true,
        sort: true,
        filterOptions: {

          renderValue: (value) => {
            return <Moment format="DD/MM/YYYY">{value}</Moment>
          }
        },
        customBodyRender: (value) => {

          return <Moment format="DD/MM/YYYY">{value}</Moment>

        } 
      }
    },
    {
      name: "portName",
      label: "Bunkering Port",
      options: {
        filter: FilterDisplay(),
        sort: true,
        display:isDisplay(),
      }
    },
    {
      name: "bunkeringDt",
      label: "Bunkered On",
      options: {
        filter: FilterDisplay(),
        sort: true,
        display:isDisplay(),
        
        filterOptions: {
          renderValue: (value) => {
            return <Moment format="DD/MM/YYYY">{value}</Moment>
          }
        },
         customBodyRender: (value) => {

          return <Moment format="DD/MM/YYYY">{value}</Moment>

        } 
        
      }
    },

    {
      name: "shippedOnDt",
      label: "Shipped On",
      options: {
        filter: FilterDisplay(),
        sort: true,
        display:isDisplay(),
        filterOptions: {

          renderValue: (value) => {
            return <Moment format="DD/MM/YYYY">{value}</Moment>
          }
        },
          customBodyRender: (value) => {
 
           return <Moment format="DD/MM/YYYY">{value}</Moment>
 
         } 
      }
    },
    {
      name: "arrivedonDt",
      label: "Arrived On",
      options: {
        filter: true,
        sort: true,
        filterOptions: {

          renderValue: (value) => {
            console.log(value);
            return <Moment format="DD/MM/YYYY">{value}</Moment>
          }
        },
        customBodyRender: (value) => {
          //
          return <Moment format="DD/MM/YYYY">{value}</Moment>

        } 
        
      }
      
    },

  ];
  const options = {
    responsive: 'standard',
    filterType: 'multiselect',
    selectableRows: "multiple",
    rowsPerPageOptions: [10, 15, 50, 100],
    download: false,
    
  };

  return (
    <div>

      <div> <Dialog

        open={DialogEmail}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        {/* <DialogTitle id="responsive-dialog-title">
  {"Use Google's location service?"}
</DialogTitle> */}
        <DialogContent>
          <DialogContentText>
            <p> Are you sure want to sent through Email ?</p>
            <p>If Yes press AGREE</p>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Disagree
          </Button>
          <Button onClick={()=> {sendEmailExcelExport(activeKey)}} autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog></div>


      <Box Box component="main">
        <Box pt={0} mx={3} display="block">
          <BreadcrumbPage rows={BreadcrumbList} icon={<Help onClick={handleClickOpenForm} />} />
        </Box>

        <Box pb={3} className="dataaccess">
          <Grid container spacing={3} direction={"row"} >
            <Grid item xs={12} md={4} className="relpositon">
              <Box component="div" className="Dataaccessbox">

                <h5>Customers</h5>
                <Box component="div" className="Da-container">

                  {!isEmpty(customerData) &&
                    (
                      <CustomerPagination
                        data={customerData}
                        CustomerKeyChange={onCustomerKeyChange}
                      />
                    )
                  }
                </Box>

                {/*  <Box component="div" className="Da-container datealistbox"> */}
                {/* <Box onClick={(e) => {
                    onSelectmethod(e.target.checked, customerData)
                  }
                  }>
                    <FormControlLabel control={<Checkbox checked={sellectAllcheck} />} label="Select All" />
                  </Box> */}

                {/*   {customerData.length && customerData
                    ? customerData.map((row, index) => {
                      return (
                        <Box key={index}  >

                          <Box onClick={(e) => {
                            ////
                            onChangemethod(!selectedValues.includes(customerData[index].customerKey), customerData[index].customerKey)
                          }
                          } ><div style={{ cursor: "pointer", fontSize: "16px" }}>

                              <FormControlLabel control={<Checkbox />} checked={selectedValues.includes(customerData[index].customerKey)} label={row.customerName ? row.customerName : ""} />
                              {/*row.axContractId + '-'}<EllipsisText text={row.customerName} length={15} />*/}

                {/* </div>

                          </Box>

                        </Box>
                      )
                    }) : "No data found"} */}


              </Box>
              {/* <Box component="div"
                  className="clearallbtn" >
                  <Button Button variant="outlined"
                    className="btn-style2" onClick={() => OnResetContract()} >
                    Clear All
                  </Button>
                </Box> */}
              {/*    </Box> */}




            </Grid>
            <Grid item xs={12} md={4} className="relpositon" >
              <Box component="div" className="Dataaccessbox">

                <h5>Assets</h5>

                <Box component="div" className="Da-container">
                  <Box>
                    {
                      isEmpty(contractListItems) && (
                        <>Please select customers to view their assets...</>
                      )
                    }
                  </Box>
                  {!isEmpty(contractListItems) &&
                    (
                      <TablePagination
                        data={contractListItems}
                        propKey={onpropKeyChange}
                      />
                    )
                  }
                </Box>
              </Box>

            </Grid>
            <Grid item xs={12} md={4}>
              <Box component="div" className="Dataaccessbox">

                <h5>Find Samples</h5>
                <Box component="div" className="Da-container">
                  <FormGroup>



                    <Grid container spacing={3}
                      className="pt20" >

                      <Grid item xs={12} md={12} className="dataacsbox">
                        <Box component="div">
                          <Box component="label"  >
                            Type of Data
                          </Box>
                          <FormControl variant="outlined" className={"cust-select-dc"}>
                            <Select
                              error={resultsvalidate}
                              label="typeofdata"
                              inputProps={{
                                name: 'typeofdata',
                                id: 'outlined-customer-native-simple',
                              }}
                              value={activeKey}
                              onChange={(e) => { Ontypemethod(e.target.value) }}
                            >
                              <MenuItem value={1}>Summary</MenuItem>
                              <MenuItem value={2}>List with Test Results</MenuItem>

                            </Select>
                          </FormControl>
                        </Box>
                      </Grid>



                      <Grid item xs={12} md={12}>
                        <Box component="div" >
                          <Box component="label"  >
                            Service Type
                          </Box>
                          <FormControl variant="outlined" className={"cust-select-dc"}  >
                            <Select
                              error={validate}
                              label="typeofdata"
                              inputProps={{
                                name: 'typeofdata',
                                id: 'outlined-customer-native-simple',
                              }}
                              onChange={(e) => { OnServicetypemethod(e.target.value) }}
                              value={servicedataType}
                            >
                              <option value="Fuel" style={{ cursor: "pointer" }}> Fuel</option>
                              <option value="Lube" style={{ cursor: "pointer" }}> Lube</option>
                              <option value="TOT" style={{ cursor: "pointer" }}> TOT</option>
                              <option value="BQS" style={{ cursor: "pointer" }}> BQS</option>
                            </Select>
                          </FormControl>
                        </Box>
                      </Grid>
                      {/* <Grid item xs={12} md={5}>

                        
                      </Grid>
                       */}

                      <Grid item xs={12} md={12}>
                        <Box component="div">
                          <Box component="label" /* className={"dclabel"} */  >
                            Duration
                          </Box>
                          <FormControl variant="outlined" className={"cust-select-dc"} >
                            <Select

                              label="typeofdata"
                              /* inputProps={{
                                name: 'typeofdata',
                                id: 'outlined-customer-native-simple',
                                
                              }} */
                              name={{ dropdownvalue }}
                              //defaultValue={1}
                              value={Duration}
                              onChange={(value) => ondropdown(value.target.value)}
                            >
                              <MenuItem value="Custom" >Custom</MenuItem>
                              <MenuItem value="Last 1 Month">Last 1 Month</MenuItem>
                              <MenuItem value="Last 2 Month">Last 2 Month</MenuItem>
                              <MenuItem value="Last 6 Month">Last 6 Month</MenuItem>
                              <MenuItem value="Last 12 Month">Last 12 Month</MenuItem>
                              <MenuItem value="Last 24 Month">Last 24 Month</MenuItem>




                            </Select>
                          </FormControl>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={5}>
                        <Box component="span" width={0.5} className=" date-input pad-right-1"   >
                          <Box>
                            From
                          </Box>
                          <KeyboardDatePicker
                            margin="normal"
                            format="DD/MM/YYYY"
                            value={formObj.ReportedFromDate}
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                            onChange={(e) => { handleDateData(e._d, "Fromdate") }}
                          />

                        </Box>
                      </Grid>
                      <Grid item xs={12} md={5}>

                        <Box component="span" width={0.5} className=" date-input pad-right-1"   >
                          <Box>
                            To
                          </Box>
                          <KeyboardDatePicker
                            margin="normal"
                            format="DD/MM/YYYY"
                            value={formObj.ReportedToDate}
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                            onChange={(e) => { handleDateData(e._d, "Todate") }}
                          />

                        </Box>
                      </Grid>
                    </Grid>
                    <Grid>
                      <Box >


                        <Box component="div" display="flex" py={1} justifyContent="Center"  >
                          <Button Button variant="outlined"
                            className="btn-style2 mr-20" onClick={() => OnResetchange()} >
                            Reset All
                          </Button>

                          <Button Button variant="outlined"
                            className="btn-style2" onClick={() => getDataAccessfilter("")} >
                            Search
                          </Button>
                        </Box>

                      </Box>
                    </Grid>
                    <Button Button variant="outlined"
                      className="btn-style2 mr-20" onClick={() => getSummaryResults(activeKey)}>
                      Export to Excel
                    </Button>





                  </FormGroup>

                </Box>


              </Box>

            </Grid>
          </Grid>
          <Grid container spacing={3} direction={"row"} >
            <Grid item xs={12} md={12} className="reportstablehead">
              <ThemeProvider theme={getMuiTheme()}>
                <MUIDataTable
                  title={"Downloads"}
                  className={classes.tableBody}
                  data={FilterData}

                  columns={columns}
                  options={options}
                />
                {/* <Confirmation open={openAlert} onClose={handleClose} onHandleSubmit={onAlertSubmit} BMhistorydata={Bunkermasterhistory} /> */}
              </ThemeProvider>
              {/* <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>Sample No </StyledTableCell>
                      <StyledTableCell >  Customer   </StyledTableCell>
                      <StyledTableCell>Status</StyledTableCell>
                      <StyledTableCell>Registered On </StyledTableCell>
                      <StyledTableCell>Bunkering Port</StyledTableCell>
                      <StyledTableCell> Bunkered On </StyledTableCell>
                      <StyledTableCell>Shipped On</StyledTableCell>
                      <StyledTableCell>Arrived On </StyledTableCell>
                     

                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {FilterData.length !== 0 ? FilterData.map((row) => (
                      <StyledTableRow key={row.name}>
                        <StyledTableCell component="th" scope="row">
                          {row.sampleControlNoCd}
                        </StyledTableCell>
                        <StyledTableCell>{row?.customerName}</StyledTableCell>
                        <StyledTableCell>{row.status}</StyledTableCell>
                        <StyledTableCell><Moment format="DD/MM/YYYY">{row.registrationDt}</Moment></StyledTableCell>
                        <StyledTableCell>{row.portName}</StyledTableCell>
                        <StyledTableCell><Moment format="DD/MM/YYYY">{row.bunkeringDt}</Moment></StyledTableCell>
                        <StyledTableCell><Moment format="DD/MM/YYYY">{row.shippedOnDt}</Moment></StyledTableCell>
                        <StyledTableCell><Moment format="DD/MM/YYYY">{row.arrivedonDt}</Moment></StyledTableCell>
                                            </StyledTableRow>
                    )) : <></>}
                  </TableBody>
                </Table>
              </TableContainer> */}

            </Grid>



          </Grid>
        </Box>
      </Box>
      <div>
            <Box component="div" className="pos_relative">


              {/*<Button onChange={handleClickOpen}/>*/}

              <Dialog
                open={openform}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
              >
                <DialogTitle id="scroll-dialog-title" color="white">Downloads</DialogTitle>
                <DialogContent dividers={scroll === 'paper'}>
                  <DialogContentText
                    id="scroll-dialog-description"
                    //ref={descriptionElementRef}
                    tabIndex={-1}
                  >
                    <p className="subtitle">Help On Downloads</p><br />
                    <img className="maxwidth100" src="/assets/images/Report_Downloadhelppage1.jpg"></img><br /><br />
                    <p>
                    <li>Customers panel shows all the customers</li><br/>
                    <li>Select <CheckBoxIcon color="primary"/> to select particular customers</li><br/>
                    <li>Assets panel shows all the assets of customers</li><br/>
                    <li>Select <CheckBoxIcon color="primary"/> to select particular assets</li><br/>
                    <li>Find Samples panel shows list of sections</li><br/>
                    <li>In Type of Data section we can select types of data such as Summary and List With Test Results</li><br/>
                    <li>In Service Type section we can select types of services such as Fuel, Lube and Tot</li><br/>
                    <li>In Duration section we can select duration upto 24 months</li><br/>
                    <li>In From To date section what we select in Duration section it set date manually</li><br/>
                    <li>Click on <img src={Resetall} alt="" width="70px" height="70px"/> will reset changes made in Find Samples panel</li><br/>
                    <li>Click on <img src={search} alt="" width="70px" height="70px"/> will show the datas in MUI-Datatable</li><br/>
                    <li>Click Export To EXcel button <img src={Exporttoexcel} alt="" width="200px" height="200px"/> to download the table in excel</li><br />
                    <img src={email} alt="" width="300px" height="300px"/><br/><br/>
                    <li>If Export To Excel functionality takes much time to download excel document , sent through email dialog box will open</li><br/>
                    <li>Click on <img src={Agree} alt="" width="70px" height="70px"/> excel document will send to email</li>
                    </p>
                   <br/>
                    <img className="maxwidth100" src="/assets/images/Report_Downloadhelppage2.jpg"></img><br /><br />
                    <p>
                   <li>Click search button <img src={searchicon} alt="" width="40px" height="40px"/> to search the entire table</li><br />
                                 <li>Click print button <img src={printicon} alt="" width="40px" height="40px"/> to open the print options</li><br />
                                 <li>Click view column button <img src={viewcolumnicon} alt="" width="40px" height="40px"/> to display column name fields</li><br />
                                 <li>Click filter button <img src={filtericon} alt="" width="40px" height="40px"/> to open the filter options</li><br />
                                 </p>
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClickClose}>Close</Button>
                </DialogActions>
              </Dialog>
            </Box>
          </div>
    </div >
  );
}
export default Dataaccess;
